import { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Flex from "../../../../../../../../components/Flex";
import CustomTabs from "../../../../../../../../components/app/CustomTabs";
import { roleFilter } from "../../../../../../../../utils/utils";

const PatientAssementLayout = () => {
  const [activeTab, setActiveTab] = useState<string>(() => {
    const currentTab = location.pathname.split("/").pop();
    return currentTab == "assessments" ? "" : (currentTab as string);
  });
  const navigate = useNavigate();

  return (
    <Flex flexDirection={"column"}>
      {/* Tabs and Filter Bar Combined */}

      {/* todo: need to remove div and use Flex component */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid #e0e0e0",
          paddingBottom: "8px",
          flexWrap: "wrap",
        }}
      >
        <CustomTabs
          tabsData={roleFilter({
            list: TABS_DATA,
            compWith: {
              assessmentForms: true,
              sendAssessmentForms: true,
            },
          })}
          value={activeTab}
          onChange={(v) => {
            setActiveTab(v);
            navigate(v);
          }}
        />
      </div>

      <Outlet />
    </Flex>
  );
};

export default PatientAssementLayout;

const TABS_DATA = [
  {
    value: "",
    label: "Assessments",
  },
  {
    value: "schedule",
    label: "Scheduled Assessment",
  },
];
